// extracted by mini-css-extract-plugin
module.exports = {"downloads":"Downloads_downloads__2esDe","option":"Downloads_option__meaAm"};